module.exports = __webpack_public_path__ + "img/lsdd.53b6ca1a.png";